import { TimeSavedEnum } from "@virtual-brain-lib/types";

export const TimeSavedOptions: Record<TimeSavedEnum, string> = {
	[TimeSavedEnum.M15_30]: "15-30 mins",
	[TimeSavedEnum.H1]: "~1 hour",
	[TimeSavedEnum.HALF_DAY]: "Half a day (~4h)",
	[TimeSavedEnum.FULL_DAY]: "Full day (~8h)",
	[TimeSavedEnum.MULTI_DAYS]: "Multiple days",
	[TimeSavedEnum.WEEK_1]: "~1 week",
};
